import { makeStyles } from '@material-ui/core/styles';
import { NutritionPlan } from 'api/generated';
import { FC } from 'react';
import { DeleteButton, SaveButton, Toolbar, ToolbarProps } from 'react-admin';

const useStyles = makeStyles({
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export const NutritionPlanToolbar: FC<ToolbarProps> = (props) => {
  const nutritionPlanRecord = props.record as NutritionPlan;
  const { title } = nutritionPlanRecord;
  return (
    <Toolbar {...props} classes={useStyles()}>
      <SaveButton label="Save" disabled={props.pristine} />
      <DeleteButton
        confirmTitle="Nutrition Plan remove"
        confirmContent={`Are you sure you want to delete item "${title}"?`}
        label="Remove"
        mutationMode="optimistic"
      />
    </Toolbar>
  );
};
